<template>
    <div :class="[companyClass , canScroll]">
        <div class="page-mobilemoneyprovider flex column mb-20">
            <div class="page-header">
				<h1 class="pageTitle">Mobile Money Providers</h1>
				<h4>mobile money provider </h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>settings</el-breadcrumb-item>
					<el-breadcrumb-item>mobile money providers</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

            <div class="mt-0">
				<div style="float: right;">
					<el-button v-show="showDelete && userPermissionsFilter.deletemobileprovider" type="danger" icon="el-icon-delete" 
						@click="deleteSelectedPrompt"></el-button>
					<el-button v-show="!showDelete && userPermissionsFilter.addmobileprovider"  type="primary" icon="el-icon-plus"
						@click="addProvider"></el-button>
				</div>
			</div>

             <div class="toolbar-box flex">
			<div class="search-box box grow">
				<div><i class="mdi mdi-magnify"></i></div>
				<input v-model="search" placeholder="Search..."/>
			</div>
			<div class="pagination-box animated fadeInRight">
				<div class="select-box">
					<el-select v-model="paginationInfo.pageSize" placeholder="Rows per page" size="mini">
						<el-option value="10" label="10"></el-option>
						<el-option value="15" label="15"></el-option>
						<el-option value="20" label="20"></el-option>
						<el-option value="30" label="30"></el-option>
						<el-option value="50" label="50"></el-option>
						<el-option value="100" label="100"></el-option>
					</el-select>
				</div>
				<div class="label">/page</div>
			</div>
			<div class="csv-box animated fadeInRight">
				<button @click="downloadData">download csv ({{total}})</button>
			</div>
		</div>

        <resize-observer @notify="handleResize" />
        
		 <div class="table-box card-base card-shadow--medium box grow" id="table-wrapper" v-loading="!asyncComponent">
				<div :style="{ 'width': width + 'px' }">
					<!-- v2-table -->
					<component :is="asyncComponent" ref="table"
						:data="list"
						:height="height"
						:border="false"
						:total="total"
						:lazy-load="false"
						:loading="loading"
						class="styled"
						:class="{'mobile':isMobile}"
						@page-change="handlePageChange"
						:pagination-info="paginationInfo"
						:default-sort="{prop:sortingProp, order:sortingOrder}"
						@sort-change="handleSortChange"
						@select-change="handleSelectChange"
						:show-summary="showSummary"
						:shown-pagination="shownPagination">
						<v2-table-column type="selection" width="45"></v2-table-column>
						<v2-table-column label="Mobile Provider" prop="name" sortable :width="width-150-70-45"
						align="left"></v2-table-column>
						
						<v2-table-column label="Added On" prop="createdOnStr" sortable width="150"
						align="center"></v2-table-column>
						

						<v2-table-column label="Action" width="70" :fixed="isMobile?'':'right'">
							<template slot-scope="row">
								<div class="custom-action-row">
									<el-button @click="print(row)"><i class="mdi mdi-eye"></i></el-button>
								</div> 
							</template>
						</v2-table-column>
					</component><!-- v2-table -->

				</div>
			</div>
        </div>

       

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :before-close="handleClose">
            <el-form :model="mobileMoneyProvider">
                <el-form-item label="Mobile Provider Name">
                    <el-input v-model="mobileMoneyProvider.name" auto-complete="off"
                    name="name" v-validate="'required'" data-vv-as="mobile provider name"
					:readonly="readOnlyMode" @blur="propertyChanged"></el-input>
                     <transition name="fade">
                        <span class="danger-text">{{ errors.first('name') }}</span>
                    </transition>
                </el-form-item>
                <el-form-item label="Operational Countries">
                    <el-select
                    class="w-100"
                        v-model="mobileMoneyProvider.countryIds"
                        multiple
                        filterable
						clearable
                        allow-create
                        default-first-option
                        placeholder="Choose operational countries"
                        name="countries" v-validate="'required'" 
                        data-vv-as="operational countries" 
						:disabled="readOnlyMode" @change="propertyChanged">
                        <el-option
                        v-for="item in countries"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                     <transition name="fade">
                        <span class="danger-text">{{ errors.first('name') }}</span>
                    </transition>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">Cancel</el-button>
                <el-button type="primary" @click="validateAndSave" :disabled="readOnlyMode">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/' 
import { bus } from '@/main'
import { Validator } from 'vee-validate'

export default {
    name: 'MobileMoneyProvider',
    data() {
        return {
            dialogTitle: 'add mobile money provider',
            mobileMoneyProvider: {
                id: 0,
                name: '',
                countryIds: []
            }
        }
	},
	computed: {
		canAddProvider() {
			return this.companyPartnerTrans.id == 0 &&
			this.userPermissionsFilter.addmobileprovider;
		},
		canUpdateProvider() {
			return this.companyPartnerTrans.id > 0 &&
			this.userPermissionsFilter.editmobileprovider;
		},
		readOnlyMode() {
			return !(this.userPermissionsFilter.addmobileprovider
			|| this.userPermissionsFilter.editmobileprovider);
		}
	},
    methods: {
        addProvider() {
            this.dialogFormVisible = true;
        },
        cancelSave() {
            this.closeDialog();
        },
        validateAndSave() {
            let self = this;
            console.log(this.mobileMoneyProvider);
             this.$validator.validateAll()
            .then(result=> {
                if(result){
                    self.addMobileMoneyProvider(self.mobileMoneyProvider)
                    .then(response=> {
                        if(response.id > 0)
                        {
                            self.successMessage(`${response.name} has been added successfully.`);
                            self.closeDialog();
							self.refreshMobileProviders();
							self.closeDialog();
                        }
                    });
                }
                else{
                    this.errorMessage('enter missing fields.');
                }
            });
            //
        },
        deleteSelectedProviders() {
			this.deleteMobileMoneyProvider(this.selectedIds)
			.then(result=> {
				if(result)
				{
					this.refreshMobileProviders();
				}
			});
        },
        closingDialog() {
            this.mobileMoneyProvider = {
                id: 0,
                name: '',
                countryIds: []
			}
			this.$validator.reset();
        },
        refreshMobileProviders() {
            this.getMobileMoneyProviders(this.currentPage, this.paginationInfo.pageSize)
            .then(result=> this.tableRefreshed(result))
			.catch(err=> this.tableRefreshed(this.defaultListResult));
        },
        print(row) { 
            this.dialogTitle = `update ${row.name}`;
            this.dialogFormVisible = true;
            this.mobileMoneyProvider = row;
        },
		downloadData() {
			this.getMobileMoneyProviders(this.currentPage, this.paginationInfo.pageSize)
			.then(result=> {
				if(result.items)
					this.downloadCSV(result.items.map(p=> {
						var c = {
							Name: p.name,
							CreatedOn: p.createdOnStr
						};

						return c;
					}));
			})
			.catch(err=> this.errorMessage('Error downloading data.'));
		},
    },
    created() {
		this.closeDialogEvent = 'closingDialog';
		this.saveEvent = 'validateAndSave';
        this.deleteEvent = 'deleteSelectedProviders';
		this.refreshListEvent = 'refreshMobileProviders';
		this.$on(this.refreshListEvent, this.refreshMobileProviders);
		this.$on(this.deleteEvent, this.deleteSelectedProviders);
		this.$on(this.saveEvent, this.validateAndSave);
		this.$on(this.closeDialogEvent, this.closingDialog);

        this.getCountries();
        this.refreshMobileProviders();
    },
    mixins: [PermissionsMixins]
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';
.page-mobilemoneyprovider {
    &.overflow {
        overflow: auto;
    }

    .table-box {
        overflow: hidden;
    }
}
</style>
<style lang="scss">
@import '../../assets/scss/_variables';
.page-mobilemoneyprovider {
	.custom-action-row {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.el-button {
			padding: 1px 5px;
		}
	}

	.toolbar-box {
		margin-top: 20px;

		.search-box {
			& > div {
				width: 20px;
				display: inline-block;
			}

			margin-bottom: 10px;

			i {
				display: inline-block;
				width: 22px;
			}

			input {
				outline: none;
				background: transparent;
				border: none;
				font-size: 15px;
				position: relative;
				padding: 0;
				margin-left: -20px;
				display: inline-block;
				padding-left: 20px;
				box-sizing: border-box;
				top: -1px;
				width: 100%;
				color: $text-color;
			}

			.icons-tot {
				margin-right: 20px;
			}
		}

		.pagination-box {
			width: 120px;
			margin: 0 15px;

			.select-box {
				width: 70px;
				display: inline-block;
			}

			.label {
				width: 50px;
				display: inline-block;
			}

			.el-input__inner {
				height: 22px;
				border: none;
				background: transparent;
				font-size: 16px;
				text-align: right;
				font-family: inherit;
				padding-right: 20px;
				color: $text-color;
			}

			.el-input__suffix {
				right: -3px;

				.el-select__caret {
					color: transparentize($text-color, 0.7);
				}
			}
		}

		a, button {
			padding: 0;
			margin: 0 15px;
			background: transparent;
			border: none;
			outline: none;
			font-family: inherit;
			font-size: inherit;
			cursor: pointer;

			border-bottom: 1px solid;
			text-decoration: none;
			color: $text-color;
			&:hover {
				opacity: .6;
			}
		}

		a {
			margin-right: 0;
		}
	}

	.sel-string {
		.sel {
			background: transparentize($text-color, 0.8);
			border-radius: 5px;
			text-transform: uppercase;
		}
	}
}

@media (max-width: 768px) {
	.page-mobilemoneyprovider {
		.toolbar-box {
			display: block;
			overflow: hidden;
			font-size: 80%;
		
			& > * {
				display: inline-block;
				min-width: 120px;
				height: 22px;
				background: rgba(0, 0, 0, 0.04);
				padding: 4px;
				margin: 3px !important;
			}
		}
	}
}
</style>


